import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "/component/base";
import OnboardingModal from "/component/modal/OnboardingModal";

const SignUpSignInButton = () => {
  const [showModal, setShowModal] = useState(false);

  const { t } = useTranslation("partial-signUpSignInButtton");

  return (
    <>
      <Button
        variant="tertiary"
        onClick={() => {
          setShowModal(true);
        }}
      >
        {t("signInSignUp")}
      </Button>
      {showModal && <OnboardingModal onClose={() => setShowModal(false)} />}
    </>
  );
};

export default SignUpSignInButton;
